export default "__VITE_ASSET__O9MNZ6hp__";